import { render } from "./ProviderReferralNotesOverlay.vue?vue&type=template&id=a3e342d0&scoped=true&lang=pug"
import script from "./ProviderReferralNotesOverlay.vue?vue&type=script&lang=js"
export * from "./ProviderReferralNotesOverlay.vue?vue&type=script&lang=js"

import "./ProviderReferralNotesOverlay.vue?vue&type=style&index=0&id=a3e342d0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3e342d0"]])

export default __exports__